import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@roger/ui-components';
import type { GoalProgressDetail } from '../../services/api/types.gen';
import {
  formatDateForDisplay,
  parseISOToLocalDate,
} from '../../utils/dateUtils';

interface GoalPerformanceHistoryTableProps {
  progressHistory: GoalProgressDetail[];
}

const GoalPerformanceHistoryTable: React.FC<
  GoalPerformanceHistoryTableProps
> = ({ progressHistory }) => {
  const sortedProgress = [...progressHistory].sort(
    (a, b) =>
      (parseISOToLocalDate(b.task_date)?.getTime() ?? 0) -
      (parseISOToLocalDate(a.task_date)?.getTime() ?? 0)
  );

  if (sortedProgress.length === 0) return null;

  return (
    <Table className='min-w-[560px]'>
      <TableHeader>
        <TableRow>
          <TableHead className='h-8 px-2 py-1 text-[11px] font-medium'>
            Date
          </TableHead>
          <TableHead className='h-8 px-2 py-1 text-[11px] font-medium'>
            Performed by
          </TableHead>
          <TableHead className='h-8 px-2 py-1 text-[11px] font-medium'>
            Progress
          </TableHead>
          <TableHead className='h-8 px-2 py-1 text-[11px] font-medium'>
            Note
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {sortedProgress.map(p => (
          <TableRow key={p.id}>
            <TableCell className='px-2 py-1.5 text-xs align-top'>
              {formatDateForDisplay(p.task_date)}
            </TableCell>
            <TableCell className='px-2 py-1.5 text-xs text-muted-foreground align-top'>
              {/* An imported row was recorded in Kinnser, not in Roger. The
                  clinician is the same human when the account mapped, but the
                  where must not be silently misstated. */}
              {p.imported_at
                ? p.performed_by_email
                  ? `${p.performed_by_email} · in External EMR`
                  : 'Recorded in External EMR'
                : (p.performed_by_email ?? '—')}
            </TableCell>
            <TableCell className='px-2 py-1.5 text-xs align-top'>
              {p.progress_score ?? '—'}
            </TableCell>
            <TableCell className='px-2 py-1.5 text-xs text-muted-foreground align-top'>
              {p.progress_note ?? ''}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default GoalPerformanceHistoryTable;
